/**
 * Frontend Sales-Rollen/Caps (Spiegel zu server salesRoles).
 */
import { getRoleId, isPowerUser, canSeeMgmt, canAccessOffers, ROLE_ADMIN, ROLE_GL } from "./roles.js";

export function getSalesCaps(user) {
  const roleId = getRoleId(user);
  const power = isPowerUser(user);
  const mgmt = canSeeMgmt(user);
  const isAdminOrGl = roleId === ROLE_ADMIN || roleId === ROLE_GL;
  return {
    roleId,
    canAccess: power,
    canPrepare: power,
    canFinalize: power,
    canMarkSent: power,
    canManagePayments: mgmt,
    canCancel: mgmt,
    canManageSettings: isAdminOrGl,
    canViewInternalCalc: power,
    canViewMargin: isAdminOrGl,
  };
}

export function canAccessSalesUi(user, hasFeature) {
  return getSalesCaps(user).canAccess && !!hasFeature?.("sales_documents_enabled");
}

export function shouldShowDashboardVerkaufTile(user, hasFeature) {
  return canAccessSalesUi(user, hasFeature);
}

export function shouldShowDashboardLegacyOffertenTile(user, hasFeature) {
  if (!canAccessOffers(user)) return false;
  if (hasFeature?.("sales_documents_enabled")) return false;
  return true;
}

/**
 * Verkauf-Hub: eine Offertenwelt + Rechnungen + optionale Module hinter Flags.
 * Kacheln nur mit Titel (wie Dashboard-Schnellzugriff).
 */
export function getVerkaufHubTiles(user, hasFeature) {
  const caps = getSalesCaps(user);
  if (!canAccessSalesUi(user, hasFeature)) return [];

  const invoicesOn = !!hasFeature?.("sales_invoices_enabled");
  const tiles = [];

  tiles.push({
    id: "offerten",
    to: "/verkauf/offerten",
    title: "Offerten",
  });

  if (invoicesOn) {
    tiles.push({
      id: "rechnungen",
      to: "/rechnungen",
      title: "Rechnungen",
    });
  }

  if (caps.canManagePayments && invoicesOn) {
    tiles.push({
      id: "debitoren",
      to: "/debitoren",
      title: "Debitoren",
    });
  }

  if (hasFeature?.("sales_templates_enabled")) {
    tiles.push({
      id: "vorlagen",
      to: "/verkauf/vorlagen",
      title: "Vorlagen",
    });
  }

  if (hasFeature?.("sales_ai_enabled")) {
    tiles.push({
      id: "ki",
      to: "/verkauf/ki",
      title: "KI-Assistent",
    });
  }

  if (hasFeature?.("sales_knowledge_enabled")) {
    tiles.push({
      id: "wissensbasis",
      to: "/verkauf/wissensbasis",
      title: "Wissensbasis",
    });
  }

  if (hasFeature?.("sales_sharepoint_sync_enabled")) {
    tiles.push({
      id: "sharepoint",
      to: "/verkauf/sharepoint",
      title: "SharePoint",
    });
  }

  if (caps.canManageSettings) {
    tiles.push({
      id: "einstellungen",
      to: "/verkauf/einstellungen",
      title: "Einstellungen",
    });
  }

  return tiles;
}
